import { useState, useEffect } from "react";
import { useLicense } from "../../../context/licenseContext";

export default function useSettingsPermissions() {
    const { currentLicense } = useLicense();
    const [permissions, setPermissions] = useState(() => {
        try {
            const saved = localStorage.getItem("currentPermissions");
            return saved ? JSON.parse(saved) : null;
        } catch {
            return null;
        }
    });

    useEffect(() => {
        const handleStorage = () => {
            try {
                const saved = localStorage.getItem("currentPermissions");
                setPermissions(saved ? JSON.parse(saved) : null);
            } catch {
                setPermissions(null);
            }
        };
        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, []);

    useEffect(() => {
        try {
            const saved = localStorage.getItem("currentPermissions");
            setPermissions(saved ? JSON.parse(saved) : null);
        } catch {
            setPermissions(null);
        }
    }, [currentLicense?.licenseNo]);

    const isOwnerOrAdmin =
        currentLicense?.title === "owner" || currentLicense?.title === "admin";
    const isOwnerAdminOrManager = isOwnerOrAdmin || currentLicense?.title === "manager";

    return {
        canSeeCompanyProfile: isOwnerOrAdmin,
        // Every business type reports its supply chain (vendors + customers).
        canSeeSupplyChain: isOwnerAdminOrManager,
        canSeeEmployees:
            isOwnerOrAdmin ||
            !!permissions?.can_view_user_permissions ||
            !!permissions?.can_add_employees ||
            !!permissions?.can_edit_permissions,
        canSeeLocations: isOwnerOrAdmin,
        canSeePayments: isOwnerOrAdmin,
        canSeePricing: isOwnerOrAdmin || !!permissions?.can_set_prices,
        canSeeAccountProfile: true,
        canSeePreferences: true,
        canSeeFaq: true,
        canSeeTutorials: true,

        canAddEmployees: isOwnerOrAdmin || !!permissions?.can_add_employees,
        canEditPermissions: isOwnerOrAdmin || !!permissions?.can_edit_permissions,
        canViewPermissions: isOwnerOrAdmin || !!permissions?.can_view_user_permissions,

        isOwnerOrAdmin,
        permissions,
        title: currentLicense?.title,
    };
}
